export enum ApprovementStatus {
  ACCEPTED = 'Accepted',
  PENDING = 'Pending',
  TOKEN_EXPIRED = 'Token expired',
}
